import React from 'react';
import { Route } from 'react-router-dom';

import RequireSuperAdmin from '../../../../components/RequireSuperAdmin';
import CorIdentificacao from '../../Adm/Cores/dadosGerais';
import CorListagem from '../../Adm/Cores/listagem';
import DadosAcessos from '../../Adm/DadosAcessos';
import DadosLogs from '../../Adm/DadosLogs';
import DadosRelatorios from '../../Adm/DadosRelatorios';
import DominioIdentificacao from '../../Adm/Dominios/dadosGerais/dominio';
import DominioListagem from '../../Adm/Dominios/listagem';
import FichaUsuario from '../../Adm/FichaUsuario';
import FluxoAdminModeloIdentificacao from '../../Adm/FluxosAdmin/dadosGerais/modelo';
import FluxosAdminListagem from '../../Adm/FluxosAdmin/listagem';
import FluxosProaqIndex from '../../Adm/FluxosProaq';
import FluxoProaqFicha from '../../Adm/FluxosProaq/FluxoProaqFicha';
import FluxoProaqVinculos from '../../Adm/FluxosProaq/FluxoProaqVinculos';
import InformeFicha from '../../Adm/Informes/InformesFicha';
import AdminInforme from '../../Adm/Informes/InformesIndex';
import ListaUsuarios from '../../Adm/ListaUsuarios';
import ModuloIdentificacao from '../../Adm/ModulosSisaf/dadosGerais/modulo';
import ModulosSisafListagem from '../../Adm/ModulosSisaf/listagem';
import SetorDafIdentificacao from '../../Adm/SetoresDaf/dadosGerais';
import SetorDafListagem from '../../Adm/SetoresDaf/listagem';

const AdmRoutes = () => {
  return (
    <>
      <Route path="adm/usuarios" element={<ListaUsuarios />} />
      {/* Rotas do SuperAdmin - inicio*/}
      <Route element={<RequireSuperAdmin />}>
        {/* Informes */}
        <Route path="adm/informes" element={<AdminInforme />} />
        <Route
          path="adm/informes/ficha/dadosgerais"
          element={<InformeFicha />}
        />
        <Route
          path="adm/informes/ficha/:id/dadosgerais"
          element={<InformeFicha />}
        />
        {/* Domínios */}
        <Route path="adm/dominios" element={<DominioListagem />} />
        <Route
          path="adm/dominios/dominio/:id/dadosgerais"
          element={<DominioIdentificacao />}
        />
        <Route
          path="adm/dominios/dominio/dadosgerais"
          element={<DominioIdentificacao />}
        />
        {/* Cores */}
        <Route path="adm/cores" element={<CorListagem />} />
        <Route
          path="adm/cores/cor/:id/dadosgerais"
          element={<CorIdentificacao />}
        />
        <Route
          path="adm/cores/cor/dadosgerais"
          element={<CorIdentificacao />}
        />
        {/* Módulos Sisaf */}
        <Route path="adm/modulossiaf" element={<ModulosSisafListagem />} />
        <Route
          path="adm/modulossiaf/modulo/:id/dadosgerais"
          element={<ModuloIdentificacao />}
        />
        <Route
          path="adm/modulossiaf/modulo/dadosgerais"
          element={<ModuloIdentificacao />}
        />

        {/* Setores DAF */}
        <Route path="adm/setores" element={<SetorDafListagem />} />
        <Route
          path="adm/setores/setor/:id/dadosgerais"
          element={<SetorDafIdentificacao />}
        />
        <Route
          path="adm/setores/setor/dadosgerais"
          element={<SetorDafIdentificacao />}
        />
      </Route>
      {/* Rotas do Admin - fim */}

      <Route path="adm/acessos" element={<DadosAcessos />} />
      <Route path="adm/logs" element={<DadosLogs />} />
      <Route path="adm/relatorios" element={<DadosRelatorios />} />
      <Route path="adm/fluxosproaqs" element={<FluxosProaqIndex />} />

      {/* Fluxos Proaq */}
      <Route
        path="adm/fluxosproaqs/fluxoproaq/ficha/:id/dadosgerais"
        element={<FluxoProaqFicha />}
      />
      <Route
        path="adm/fluxosproaqs/fluxoproaq/ficha/dadosgerais"
        element={<FluxoProaqFicha />}
      />
      <Route
        path="adm/fluxosproaqs/fluxoproaq/ficha/:id/vinculos"
        element={<FluxoProaqVinculos />}
      />
      <Route
        path="adm/fluxosproaqs/fluxoproaq/ficha/vinculos"
        element={<FluxoProaqVinculos />}
      />

      {/* Dados do Usuário */}
      <Route
        path="adm/usuarios/ficha/:id/dadosgerais"
        element={<FichaUsuario />}
      />

      {/* Fluxos Administrativos */}
      <Route path="adm/fluxos-adm" element={<FluxosAdminListagem />} />
      <Route
        path="adm/fluxos-adm/modelo/:id/dadosgerais"
        element={<FluxoAdminModeloIdentificacao />}
      />
      <Route
        path="adm/fluxos-adm/modelo/dadosgerais"
        element={<FluxoAdminModeloIdentificacao />}
      />
    </>
  );
};

export default AdmRoutes;
